import {Component, NgModule, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ChartOptions, ChartType, Chart, CoreChartOptions} from 'chart.js';
import {BaseChartDirective} from 'ng2-charts';
import * as pluginDataLabels from 'chartjs-plugin-datalabels';
import {Router} from '@angular/router';
import {QueryService} from '../../Services/query.service';
import {AppComponent} from '../../app.component';
import {ClientRequest} from '../../Interfaces/ClientRequest';
import {Subscription, timer} from 'rxjs';
import {GateStatus} from '../../Interfaces/GateStatus';
import {User} from '../../Interfaces/User';
import {GateMove} from '../../Interfaces/GateMove';
import {GlobalEventsManager} from '../../GlobalEventManager';
import {SharedVarService} from '../shared-service.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Color, LabelOptions} from 'chartjs-plugin-datalabels/types/options';
import {MatLabel} from '@angular/material/form-field';


@Component({
  selector: 'app-charts',
  templateUrl: './charts.component.html',
  styleUrls: ['./charts.component.css']
})


export class ChartsComponent implements OnInit, OnDestroy {
  clientRequest: ClientRequest;
  subscription: Subscription;
  subscription2: Subscription;
  cusSubscription: Subscription;
  gateStatus: GateStatus [] ;
  gateMove: GateMove [] ;
  private  myUser: User;
  cancelled: string = "0";
  completed: string = "0";
  trouble: string = "0";
  in_progress: string = "0";
  rmCount: number = 0;
  riCount: number = 0;
  reCount: number = 0;
  dmCount: number = 0;
  diCount: number = 0;
  deCount: number = 0;
  public savedList: string;
  public savedLists : {code:string, description:string}[] = [];
  showCharts: boolean = true;
  activePointLabel: string;



  @ViewChild(BaseChartDirective, { static: true }) chart: BaseChartDirective;


  constructor(public router: Router,private  queryService: QueryService, public myApp:AppComponent,  private  globalEventsManager: GlobalEventsManager, private service: SharedVarService) {


    this.myUser = this.myApp.user;


/*
    this.myUser = {} as User;
    this.myUser.active ="Y"
    this.myUser.address_1 = "15600 JFK BLVD. Suite 400"
    this.myUser.address_2 = null
    //this.myUser.company_code ="COS"
    this.myUser.company_code ="EGN"
    this.myUser.company_name= "MAHER TERMINALS, LLC"
    this.myUser.city= "HOUSTON"
    this.myUser.email_address= null
    this.myUser.fax_number= null
    this.myUser.first_name= "Csp Craig"
    this.myUser.last_name= "Miller"
    this.myUser. maherError= null
    this.myUser.old_password= null
    this.myUser.password= ""
    this.myUser.phone_number= null
    this.myUser.company_scac= null
    this.myUser.state= "TX"
    this.myUser.userMenuReportItemsView= null
    this.myUser.user_gkey= "3798920884"
   //  this.myUser.role= "AGENT"
    this.myUser.role= "LINEOP"
 //    this.myUser.role= "HAULIER"
    this.myUser.username="CSPSSL"
    this.myUser.zip="07201"
    this.myUser.canSeeAllData = "0";




 */





  }

  ngOnInit(): void {
   Chart.register(ChartDataLabels);
    this.showCharts = true;

    this.savedLists = [];
    this.savedLists.push({"code": "ALL", "description": "All"});
    this.savedLists.push({"code": "MAIN", "description": "Main"});
    this.savedLists.push({"code": "DEPOT", "description": "Depot"});
    this.savedLists.push({"code": "MMR", "description": "MMR"});
    this.savedList = this.savedLists[0].code;

    if (this.myUser.role=='HAULIER' || this.myUser.role=='LINEOP'){
      this.getStatusCounts();
      this.allGatesWithMoveCounts();
      this.subscription2 = timer(120000, 120000).subscribe(t => {
        this.getStatusCounts();
        this.allGatesWithMoveCounts();
      });
    }else{
      this.showCharts = true;
    }
  }


  ngOnDestroy() {
    if (this.subscription2!=null){
      this.subscription2.unsubscribe();
    }
  }

  changeYard(){
    if (this.myUser.role=='HAULIER' || this.myUser.role=='LINEOP'){
      this.getStatusCounts();
      this.allGatesWithMoveCounts();
    }else{
      this.showCharts = false;
    }
  }



  private getStatusCounts(){
    this.gateStatus = null;
    this.gateStatus = []
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = this.gateStatus;
    const lhsUserObs$ = this.queryService.allGatesWithStatusCounts(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (sCounts) => {
        this.gateStatus = sCounts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.gateStatus[0].maherError != null) {

        }else{
            for (var item of this.gateStatus){
              if (item.gate_description.toUpperCase()==this.savedList){
                this.cancelled = item.cancelled;
                this.trouble = item.trouble;
                this.in_progress = item.in_progress;
                this.completed = item.completed;
              }
            }
        }

      });
  }


  private allGatesWithMoveCounts(){
    this.gateStatus = null;
    this.gateStatus = []
    this.clientRequest = null;
    this.clientRequest = {} as ClientRequest;
    this.clientRequest.user = this.myUser;
    this.clientRequest.requestData = this.gateMove;
    const lhsUserObs$ = this.queryService.allGatesWithMoveCounts(this.clientRequest);
    this.subscription = lhsUserObs$.subscribe(
      (sCounts) => {
        this.gateMove = sCounts;
      },
      error => {
        if (error.status == "401") {
          this.globalEventsManager.showLogin.emit(true);

          this.router.navigate(["login"]);
        } else {
          this.myApp.openDialog(error.message)
        }
      },
      () => {
        if (this.gateMove.length>0){
          if (this.gateMove[0].maherError != null) {

          }else{
            this.rmCount = 0;
            this.riCount = 0;
            this.reCount = 0;
            this.dmCount = 0;
            this.diCount = 0;
            this.deCount = 0;
            let chartData: any[];
            chartData = [];
            for (var item of this.gateMove) {
              if (item.gate_description.toUpperCase()==this.savedList) {
                switch (item.sub_type) {
                  case "RM":
                    this.rmCount = Number.parseInt(item.moves);
                    break;
                  case "RI":
                    this.riCount = Number.parseInt(item.moves);
                    break;
                  case "RE":
                    this.reCount = Number.parseInt(item.moves);
                    break;
                  case "DI":
                    this.diCount = Number.parseInt(item.moves);
                    break;
                  case "DE":
                    this.deCount = Number.parseInt(item.moves);
                    break;
                  case "DM":
                    this.dmCount = Number.parseInt(item.moves);
                    break;
                }
              }
            }
            chartData.push({
              data: [this.rmCount, this.riCount,this.reCount,this.dmCount,this.diCount,this.deCount],
              labels:       ["Receive Empty",
                "Receive Import",
                "Receive Export",
                'Deliver Empty',
                'Deliver Import',
                'Deliver Export'

              ],
              backgroundColor: ['rgba(77,197,229,1)','rgba(129,153,231,1)','rgba(130,231,190,1)','rgba(230,138,141,1)','rgba(242,80,89,1)','rgba(231,153,81,1)'],

            });
            this.barChartData = chartData;
          }
        }


      });
  }



  private generateNumber(i: number): number {
    return Math.floor((Math.random() * (i < 2 ? 100 : 1000)) + 1);
  }

  onChartClick = (e: any) => {
    if (e.active.length>0){
       if (e.active[0].index==0){
         this.activePointLabel = "Receive Empty";
       }else if (e.active[0].index==1){
         this.activePointLabel = "Receive Import";
       }else if (e.active[0].index==2){
         this.activePointLabel = "Receive Export";
       }else if (e.active[0].index==3){
         this.activePointLabel = "Deliver Empty";
       }else if (e.active[0].index==4){
         this.activePointLabel = "Deliver Import";
       }else if (e.active[0].index==5){
         this.activePointLabel = "Deliver Export";
       }
        this.service.setActionName(this.activePointLabel);
      this.globalEventsManager.menuFound.emit(false);
        this.service.setGate(this.savedList);
      this.router.navigate(["gateActivity"]);
    }
  };



  public chartHovered({ event, active }: { event: MouseEvent, active: {}[] }): void {
    console.log(event, active);
  }




  goToGate(fromWhere: string){
    if (fromWhere=="COMPLETED" && this.completed=="0"){
      return;
    }else if (fromWhere=="CANCELLED" && this.cancelled=="0"){
      return;
    }else if (fromWhere=="TROUBLE" && this.trouble=="0"){
      return;
    }else if (fromWhere=="IN PROGRESS" && this.in_progress=="0"){
      return;
    }
    this.globalEventsManager.menuFound.emit(false);

    this.service.setActionName(fromWhere);
    this.service.setGate(this.savedList);
    this.router.navigate(["gateActivity"]);
  }

  public barChartOptions: ChartOptions = {

    plugins: {
      datalabels: {
        display: function(context) {
          return true; // or >= 1 or ...
        },
        color: "white",
        textStrokeWidth: 2,
        textShadowColor: "black",
        textShadowBlur: 15,

        font: {
          size: 25,
          family: "Calibri",
          weight: "normal"
        },
      }
    },


    responsive: true,
    scales: {
      x: {
        display: true,
        ticks: {
          color: "white",
          textStrokeWidth: 20,
        },
      },
      y: {
        display: true,
        ticks: {
          color: "white"
        },
      },
    },
  };
  public barChartLabels: string[] =
      ["Receive Empty",
      "Receive Import",
      "Receive Export",
      'Deliver Empty',
        'Deliver Import',
      'Deliver Export'

      ];
  public barChartType: ChartType = 'bar';
  public barChartLegend = false;
  public barChartPlugins = [pluginDataLabels];

  barChartData: { backgroundColor: Color[]; data: number[] }[] = [
    { data: [0, 0, 0,0,0,0],
     backgroundColor: ['rgba(77,197,229,1)','rgba(129,153,231,1)','rgba(130,231,190,1)','rgba(230,138,141,1)','rgba(242,80,89,1)','rgba(231,153,81,1)'],


      }
  ];







}
